import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import { Calendar } from '@fullcalendar/core'
import bootstrapPlugin from '@fullcalendar/bootstrap'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import ptLocale from '@fullcalendar/core/locales/pt-br'
import { BSpinner, BToast } from 'bootstrap-vue'
import mensagens from '@/util/mensagens'
import constants from '@/util/constants'
import NotificacoesConvites from '@/views/inicio/NotificacoesConvites.vue'
import ConvitesPendentes from '@/views/inicio/ConvitesPendentes.vue'
import ConvitesCancelados from '@/views/inicio/ConvitesCancelados.vue'
import agendaUtil from '@/util/agendaUtil'
import util from '@/util'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'inicio',
  components: {
    cabecalho,
    menuLateral,
    'b-spinner': BSpinner,
    'b-toast': BToast,
    Calendar,
    FullCalendar,
    NotificacoesConvites,
    ConvitesPendentes,
    ConvitesCancelados
  },

  computed: {
    ...mapGetters('auth', ['escritorioInadimplente']),
    ...mapState('auth', ['alertaStatusEmpresa', 'nomeUsuarioLogado', 'emailUsuario', 'escritorio']),
    banners () {
      return [
        {
          imagem: '/bannerPreambuloIA.webp',
          url: this.urlCampanhaPreambuloIA,
          alt: 'Preâmbulo IA'
        }
      ]
    },
    urlCampanhaPreambuloIA () {
      const parametros = new URLSearchParams({
        utm_source: 'office',
        utm_campaign: 'usuario-office',
        utm_name: this.nomeUsuarioLogado || '',
        utm_email: this.emailUsuario || '',
        utm_office: this.escritorio || ''
      })
      return `https://preambuloia.com.br/campanha-erp?${parametros.toString()}`
    },
    deveExibirAlertaInadimplencia () {
      if (this.alertaStatusEmpresa !== null && this.alertaStatusEmpresa !== undefined) {
        return this.alertaStatusEmpresa.exibir === true
      }
      return this.escritorioInadimplente === true
    },
    mensagemAlertaInadimplencia () {
      if (this.alertaStatusEmpresa?.mensagem) {
        return this.alertaStatusEmpresa.mensagem
      }
      return 'Não identificamos pagamento de sua fatura. Por favor, entre em contato conosco para envio de comprovante ou fornecermos 2ª via e garantir que continuem aproveitando nossos serviços!'
    },
    carregandoListaDeNoticias () {
      const carregandoDados = this.flagsDeControle.carregandoDados.convites.status
      const carregandoListaNoticias = this.listaNoticias.length > 0
      return (carregandoDados || carregandoListaNoticias)
    },

    requisicaoEmAndamento () {
      const carregandoDados = this.flagsDeControle.carregandoDados.convites.status
      const manipulandoDados = this.flagsDeControle.manipulandoDados.convites.status
      return (carregandoDados || manipulandoDados)
    },

    carregandoListaDeConvites () {
      const carregandoListaDeConvites = this.listaDeConvites.length > 0
      const carregandoListaDeNotificacoes = this.listaDeNotificacoes.length > 0
      const carregandoDados = this.flagsDeControle.carregandoDados.convites.status
      return (carregandoListaDeConvites || carregandoListaDeNotificacoes || carregandoDados)
    },

    calendarOptions () {
      return {
        ...this.configuracoes,
        ...this.acoes
      }
    },

    configuracoes () {
      const vm = this
      return {
        plugins: [ dayGridPlugin, interactionPlugin, bootstrapPlugin ],
        locales: [ptLocale],
        themeSystem: 'bootstrap',
        initialView: 'dayGridWeek',
        weekends: true,
        height: 200,
        events: this.popularAgenda,
        headerToolbar: false,
        eventOrderStrict: true,
        eventOrder: '-ehEventoAniversario',
        views: {
          dayGridWeek: {
            titleFormat: { year: 'numeric', month: 'short', day: 'numeric' },
            slotLabelFormat: { hour: 'numeric', minute: '2-digit' },
            eventTimeFormat: { hour: 'numeric', minute: '2-digit', meridiem: false },
            expandRows: true,
            displayEventTime: true,
            displayEventEnd: false
          }
        },
        eventDidMount ($event) {
          agendaUtil.customizacaoLayoutEvento($event, document, vm)
        }
      }
    },

    acoes () {
      return {
        eventClick: this.editarEvento
      }
    },

    statusConvitePendente () {
      return constants.statusConvites.pendente
    },

    statusNotificacaoCancelamento () {
      return constants.statusConvites.notificacaoCancelamento
    }
  },

  data: () => {
    return {
      listaNoticias: [],
      listaDeConvites: [],
      listaDeNotificacoes: [],
      flagsDeControle: {
        carregandoDados: {
          convites: {
            status: false,
            mensagem: ''
          },
          agenda: {
            status: false,
            mensagem: ''
          },
          noticias: {
            status: false,
            mensagem: ''
          }
        },
        manipulandoDados: {
          convites: {
            status: false,
            mensagem: ''
          }
        }
      },
      dadosRetorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: []
      },
      filtroDeDiasParaApresentacaoNoticias: 60
    }
  },

  async mounted () {
    await Promise.all([
      this.obterConvites(),
      this.obterNotificacaoConvites(),
      this.obterListaNoticias()
    ])
  },

  methods: {
    async obterConvites () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao, 'convites')

        let parametrosRequisicao = {
          'limiteDeRegistros': constants.defaultRegistrosCapa.convites
        }
        const resposta = await this.axios.post('/agenda/convites-pendentes', parametrosRequisicao)
        this.listaDeConvites = resposta.data.retorno.dados
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '', 'convites')
    },

    async salvarRetornoDoConvite (parametrosRequisicao) {
      try {
        this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro, 'convites')

        const resposta = await this.axios.put('/agenda/alterar-status-convite', parametrosRequisicao)
        this.dadosRetorno.sucesso = resposta.data.retorno.sucesso
        this.dadosRetorno.mensagem = resposta.data.retorno.mensagem
        this.dadosRetorno.listaDeErros = resposta.data.retorno.listaDeErros

        this.tratarAposSalvarRegistro()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      }
      this.definirFlagManipulandoDados(false, '', 'convites')
    },

    async obterNotificacaoConvites () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao, 'convites')

        let parametrosRequisicao = {
          'limiteDeRegistros': constants.defaultRegistrosCapa.convites
        }
        const resposta = await this.axios.post('/agenda/notificacoes-pendentes', parametrosRequisicao)
        this.listaDeNotificacoes = resposta.data.retorno.dados
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '', 'convites')
    },

    async salvarRetornoNotificacaoConvite (parametrosRequisicao) {
      try {
        this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro, 'convites')

        const resposta = await this.axios.put('/agenda/confirmar-notificacao-convite', parametrosRequisicao)
        this.dadosRetorno.sucesso = resposta.data.retorno.sucesso
        this.dadosRetorno.mensagem = resposta.data.retorno.mensagem
        this.dadosRetorno.listaDeErros = resposta.data.retorno.listaDeErros

        this.tratarAposSalvarRegistro()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      }
      this.definirFlagManipulandoDados(false, '', 'convites')
    },

    tratarAposSalvarRegistro () {
      if (this.dadosRetorno.sucesso) {
        util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
      } else {
        const mensagemRetorno = this.tratarMensagensDeErro()
        util.criarAlertaToastDeErro(this, 'Aviso', mensagemRetorno)
      }
      this.obterConvites()
      this.obterNotificacaoConvites()
      this.recarregarDadosCalendario()
    },

    tratarMensagensDeErro () {
      let mensagemRetorno = this.dadosRetorno.mensagem
      const flagNotificacaoCancelamento = !util.valorVazio(this.dadosRetorno.listaDeErros.f_id)
      const flagNotificacaoAlteracaoStatus = !util.valorVazio(this.dadosRetorno.listaDeErros['convites.*.f_status'])

      if (flagNotificacaoCancelamento) {
        mensagemRetorno = mensagens.conviteCancelado
      }

      if (flagNotificacaoAlteracaoStatus) {
        mensagemRetorno = this.dadosRetorno.listaDeErros['convites.*.f_status']
      }
      return mensagemRetorno
    },

    recarregarDadosCalendario () {
      this.$refs.calendarioAgenda.getApi().refetchEvents()
    },

    async popularAgenda (calendarioDTO, callbackSucesso, callbackFalha) {
      let eventosCalendario = []

      const dataInicio = util.formatarData(calendarioDTO.start, 'YYYY-MM-DD 00:00')
      const dataFinal = util.formatarData(calendarioDTO.end, 'YYYY-MM-DD 23:59')
      let parametrosRequisicao = {
        'filtros': {
          'f_dtstart': dataInicio,
          'f_dtend': dataFinal
        }
      }
      await this.axios.post('/agenda/calendario', parametrosRequisicao)
        .then(resposta => {
          const listaEventosApi = resposta.data.retorno.dados.f_events
          listaEventosApi.map(evento => {
            eventosCalendario.push({
              id: evento.f_uuid,
              title: evento.f_summary,
              start: evento.f_dtstart,
              end: evento.f_dtend
            })
          })

          const listaAniversariosApi = resposta.data.retorno.dados.f_birthdays
          listaAniversariosApi.map(aniversario => {
            eventosCalendario.push({
              title: aniversario.f_name || '',
              start: aniversario.f_birthday,
              allDay: true,
              ehEventoAniversario: true,
              nome: aniversario.f_name || '',
              email: aniversario.f_email || '',
              foto: aniversario.f_photo,
              idCliente: aniversario.f_id,
              permitido: true,
              tipo: aniversario.tabela,
              abaCliente: resposta.data.retorno.dados.abaCliente,
              image64: aniversario.image64
            })
          })
          callbackSucesso(eventosCalendario)
        }).catch(e => {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
          callbackFalha(e)
        })
    },

    editarEvento ({ event }) {
      if (!util.valorVazio(event.id)) {
        window._Vue.$router.push({ name: 'edicao-eventos', params: { id: event.id } })
      }
    },

    async obterListaNoticias () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao, 'noticias')

        let parametrosRequisicao = {
          'limiteDeRegistros': constants.defaultRegistrosCapa.noticias,
          'filtros': {
            'date_between_start': util.formatarData(util.subtrairDiasDeUmaData(this.filtroDeDiasParaApresentacaoNoticias), 'YYYY-MM-DD')
          }
        }
        const resposta = await this.axios.post('/noticias', parametrosRequisicao)
        this.listaNoticias = resposta.data.retorno.dados
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '', 'noticias')
    },

    detalhesNoticia (id) {
      this.$router.push({ name: 'detalhes-noticias', params: { id: id } })
    },

    definirFlagManipulandoDados (status, mensagem, tipoCard) {
      this.flagsDeControle.manipulandoDados[tipoCard].status = status
      this.flagsDeControle.manipulandoDados[tipoCard].mensagem = mensagem
    },

    definirFlagCarregandoDados (status, mensagem, tipoCard) {
      this.flagsDeControle.carregandoDados[tipoCard].status = status
      this.flagsDeControle.carregandoDados[tipoCard].mensagem = mensagem
    },

    formatarDataHora (data) {
      return util.formatarData(data, 'DD/MM/YYYY')
    }
  }
}
